// src/stores/employeeStore.js
import { defineStore } from "pinia";
import { employeeService } from "@/services/employeeService";
import { useAppStore } from "@/stores/appStore";
import { toast } from 'vue3-toastify';

export const useEmployeeStore = defineStore("employeeStore", {
  state: () => ({
    employees: [],
    employee: null,
    loading: false,
    error: null,
  }),

  actions: {
    async getAllEmployees() {
      this.loading = true;

      try {
        const response = await employeeService.fetchAllEmployees();
        this.employees = response.data;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2001');
      } finally {
        this.loading = false;
      }
    },

    async getEmployee(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await employeeService.fetchEmployee(id);
        this.employee = response.data;
        return this.employee;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2002');
      } finally {
        appStore.setLoading(false);
      }
    },

    async createEmployee(userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await employeeService.fetchCreateEmployee(userData);
        this.employees.push(response.data);
      } finally {
        appStore.setLoading(false);
      }
    },

    async updateEmployee(id, userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await employeeService.fetchUpdateEmployee(id, userData);
        const index = this.employees.findIndex((b) => b.id === id);
        if (index !== -1) this.employees[index] = response.data;
      } finally {
        appStore.setLoading(false);
      }
    },

    async deleteEmployee(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        await employeeService.fetchDeleteEmployee(id);
        this.employees = this.employees.filter((b) => b.id !== id);
        toast.success("Success");
      } catch (error) {
        toast.error(error.response.data.message + ' - 2003');
      } finally {
        appStore.setLoading(false);
      }
    },
  },
});
